// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"9ef6f722","667":"6d1d064d","977":"874d75d3"}[chunkId] + ".chunk.js");